const registerModuleArray = [
  {
    moduleName: "Register Module",
    subModules: [
      {
        subModuleName: "Registrations",
        id: 1001,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "All Users",
            link: "/hr/user/all-users",
            icons: "mdi mdi-account-circle"
          },
          {
            subModuleHeading: "All Images",
            link: "/hr/user/all-register-images",
            icons: "mdi mdi-image-multiple"
          },
          {
            subModuleHeading: "Locations",
            link: "/hr/location/all-locations",
            icons: "mdi mdi-google-maps"
          },
          {
            subModuleHeading: "Register CSV",
            link: "/hr/user/user-csv-registration",
            icons: "mdi mdi-account-box"
          },
          {
            subModuleHeading: "Register Photo",
            link: "/hr/user/user-photo-register",
            icons: "mdi mdi-google-photos"
          },
          {
            subModuleHeading: "Register Locations",
            link: "/hr/location/location-registration",
            icons: " mdi mdi-google-maps"
          }
        ]
      }
    ]
  }
];

const attendanceModuleArray = [
  {
    moduleName: "Reports Module",
    subModules: [
      {
        subModuleName: "Reports",
        id: 1002,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "Day wise",
            link: "/hr/attendance/user-daily-attendance",
            icons: "mdi mdi-calendar-check"
          },
          {
            subModuleHeading: "Attendance Sheet",
            link: "/hr/attendance/user-attendance-sheet",
            icons: "mdi mdi-calendar-multiple"
          },
          {
            subModuleHeading: "Reports Sheet",
            link: "/hr/attendance/user-report-sheet",
            icons: "mdi mdi-calendar-multiple"
          },
          {
            subModuleHeading: "User Attendance",
            link: "/hr/attendance/user-attendance",
            icons: "mdi mdi-account-search"
          },
          {
            subModuleHeading: "Depart Attendance",
            link: "/hr/attendance/user-department-attendance",
            icons: "mdi mdi-account-search"
          },
          {
            subModuleHeading: "Regularize Atten",
            link: "/hr/attendance/missing-daily-attendance",
            icons: "mdi mdi-calendar-edit"
          }
          // {
          //   subModuleHeading: "User Reg-Att",
          //   link:
          //     "/hr/attendance/single-user-missing-daily-attendance",
          //   icons: "mdi mdi-calendar-edit"
          // }
        ]
      }
    ]
  }
];

const canteenModuleArray = [
  {
    moduleName: "Canteen Module",
    subModules: [
      {
        subModuleName: "Canteen",
        id: 1012,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "Day wise",
            link: "/hr/canteen/user-daily-canteen",
            icons: "mdi mdi-calendar-check"
          },
          {
            subModuleHeading: "Canteen Sheet",
            link: "/hr/canteen/user-canteen-sheet",
            icons: "mdi mdi-calendar-multiple"
          }
          // {
          //   subModuleHeading: "Reports Sheet",
          //   link: "/hr/canteen/user-report-sheet",
          //   icons: "mdi mdi-calendar-multiple"
          // },
          // {
          //   subModuleHeading: "User Canteen",
          //   link: "/hr/canteen/user-canteen",
          //   icons: "mdi mdi-account-search"
          // },
          // {
          //   subModuleHeading: "Regularize Canteen",
          //   link: "/hr/canteen/missing-daily-canteen",
          //   icons: "mdi mdi-calendar-edit"
          // }
        ]
      }
    ]
  }
];

const rulesModuleArray = [
  {
    moduleName: "Rules Module",
    subModules: [
      {
        subModuleName: "Rules",
        id: 1003,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "All Rules",
            link: "/hr/rules/all-rules",
            icons: "mdi mdi-textbox-password"
          },
          {
            subModuleHeading: "All Canteen Rules",
            link: "/hr/rules/all-canteen-rules",
            icons: "mdi mdi-textbox-password"
          },
          {
            subModuleHeading: "Add Holidays",
            link: "/hr/rules/all-holidays",
            icons: "mdi mdi-textbox-password"
          }
        ]
      }
    ]
  }
];

const accessModuleArray = [
  {
    moduleName: "Admin Module",
    subModules: [
      {
        subModuleName: "Access",
        id: 1004,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "All Access",
            link: "/access/user-access",
            icons: "mdi mdi-access-point"
          },
          {
            subModuleHeading: "All Devices",
            link: "/devices/all-devices",
            icons: "mdi mdi-cellphone-link"
          }
        ]
      },
      {
        subModuleName: "Updates",
        id: 1005,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "All Updates",
            link: "/access/all-updates",
            icons: "mdi mdi-access-point"
          }
        ]
      }
      // {
      //   subModuleName: "Reports",
      //   id: 1005,
      //   select: false,
      //   subModulesList: [
      //     {
      //       subModuleHeading: "Reporting Managers",
      //       link: "/reports/reporting-managers",
      //       icons: "mdi mdi-book-open-variant"
      //     },
      //     {
      //       subModuleHeading: "All Report",
      //       link: "/reports/manager-reports",
      //       icons: "mdi mdi-book-multiple"
      //     }
      //   ]
      // },
      // {
      //   subModuleName: "Notice",
      //   id: 1008,
      //   select: false,
      //   subModulesList: [
      //     {
      //       subModuleHeading: "All Notice",
      //       link: "/users/notice",
      //       icons: "mdi mdi-access-point"
      //     }
      //   ]
      // },

      // {
      //   subModuleName: "Task",
      //   id: 1009,
      //   select: false,
      //   subModulesList: [
      //     {
      //       subModuleHeading: "All Tasks",
      //       link: "/task/all-tasks",
      //       icons: "mdi mdi-format-list-checks"
      //     }
      //   ]
      // }
    ]
  }
];

const accountModuleArray = [
  {
    moduleName: "Accounts Module",
    subModules: [
      {
        subModuleName: "Salary",
        id: 1006,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "Generate Salary",
            link: "/account/salary/generate-salary",
            icons: "mdi mdi-currency-inr"
          },
          {
            subModuleHeading: "Generated Salary",
            link: "/account/salary/generated-salary",
            icons: "mdi mdi-account-card-details"
          },
          {
            subModuleHeading: "Edit Salary",
            link: "/account/salary/edit-salary",
            icons: "mdi mdi-pencil-box"
          }
        ]
      }
    ]
  }
];

const hrModuleArray = [
  {
    moduleName: "HR Module",
    subModules: [
      {
        subModuleName: "HR",
        id: 1007,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "Change Shift",
            link: "/hr/change-shift",
            icons: "mdi mdi-animation"
          },
          {
            subModuleHeading: "All Shift",
            link: "/hr/all-shift",
            icons: "mdi mdi-animation"
          },
          {
            subModuleHeading: "All Reg-Attendance",
            link: "/hr/all-attendance-to-regularized",
            select: false,
            icons: "mdi mdi-animation"
          },
          {
            subModuleHeading: "Depart/Design",
            link: "/hr/others",
            icons: "mdi mdi-book"
          },
          {
            subModuleHeading: "Add HOD",
            link: "/hr/add-hod",
            icons: "mdi mdi-book"
          }
          // {
          //   subModuleHeading: "Apply Leaves",
          //   link: "/user/apply-leave",
          //   select: false,
          //   icons: "mdi mdi-calendar-check"
          // },
          // {
          //   subModuleHeading: "All Leaves",
          //   link: "/hr/all-leaves",
          //   select: false,
          //   icons: "mdi mdi-animation"
          // }
        ]
      }
    ]
  }
];

const queryModuleArray = [
  {
    moduleName: "Queries Module",
    subModules: [
      {
        subModuleName: "Query",
        id: 1010,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "All Queries",
            link: "/reports/query/all-query",
            icons: "mdi mdi-ticket-confirmation"
          },
          {
            subModuleHeading: "Raise Ticket",
            link: "/reports/query/add-query",
            icons: "mdi mdi-ticket"
          }
        ]
      }
    ]
  }
];

const dprModuleArray = [
  {
    moduleName: "DPR Module",
    subModules: [
      {
        subModuleName: "DPR",
        id: 1011,
        select: false,
        subModulesList: [
          {
            subModuleHeading: "All DPR ",
            link: "/reports/dpr/all-dpr",
            icons: "mdi mdi-wall"
          },
          {
            subModuleHeading: "Create reports",
            link: "/reports/dpr/create-dpr",
            icons: "dripicons-view-apps"
          }
        ]
      }
    ]
  }
];

const adminModuleArray = [
  ...registerModuleArray,
  ...attendanceModuleArray,
  ...canteenModuleArray,
  ...hrModuleArray,
  ...rulesModuleArray,
  ...queryModuleArray
  // ...dprModuleArray
];

const superAdminModuleArray = [
  ...registerModuleArray,
  ...attendanceModuleArray,
  ...canteenModuleArray,
  ...hrModuleArray,
  ...rulesModuleArray,
  ...queryModuleArray,
  // ...dprModuleArray,
  ...accessModuleArray
];

export {
  accountModuleArray,
  adminModuleArray,
  attendanceModuleArray,
  registerModuleArray,
  rulesModuleArray,
  accessModuleArray,
  superAdminModuleArray,
  hrModuleArray,
  dprModuleArray
};
